import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchGlobalPartnerById } from 'clickNgo/services/globalPartner'
import { fetchPartnersByFilter } from 'partner360/components/QBR/api/fetchPartnersByFilter'
import { NEW_QBR_TEMP_ENTRY_ID } from 'partner360/components/QBR/configs'
import { fetchQBRDocumentPartners } from 'partner360/services/qbr/fetchQBRDocumentPartners'

import { applyChanges, IApplyChanges } from '../../../components/QBR/api/applyChanges'
import { IFetchQbrDocumentResponse } from '../../../models/qbr/IFetchQbrDocumentResponse'
import { IQBRPartner } from '../../../models/qbr/IQBRPartners'
import { CREATE_DRAFT_QBR } from '../constants'

interface ICreateDraftQbrResult {
  qbrDraft: IFetchQbrDocumentResponse
  partners: IQBRPartner[]
  documentPartnerName: string | null
}

export const createDraftQbr = createAsyncThunk<ICreateDraftQbrResult, IApplyChanges>(
  CREATE_DRAFT_QBR,
  async (params) => {
    const partnerId = params.globalPartnerId || params.partners?.[0]
    const isGlobalPartner = partnerId?.startsWith('GP')

    const documentPartnerName = isGlobalPartner
      ? (await fetchGlobalPartnerById(partnerId)).globalPartnerName
      : null

    if (isGlobalPartner && params.entryId === NEW_QBR_TEMP_ENTRY_ID) {
      // Replace the global partner ID with the IDs of all its local partners for global QBR
      const filter = JSON.stringify({ PartnerIds: params.partners || [] })
      const localPartners = await fetchPartnersByFilter(filter)
      if (localPartners.Data.length) {
        params.partners = localPartners.Data.map((partner) => partner.PartnerID)
      }
    }

    const {
      Data: [qbrDraft],
    } = await applyChanges({
      ...params,
      name: documentPartnerName,
      entryId: null,
      isNoGenerate: true,
      globalPartnerId: isGlobalPartner ? partnerId : undefined,
    })

    const partners = await fetchQBRDocumentPartners({
      entryId: qbrDraft.EntryId,
      partnerIds: qbrDraft.PartnerIDs,
      fYear: qbrDraft.FYear,
      rtm: qbrDraft.RTM,
      settings: qbrDraft.Settings,
    })

    return {
      qbrDraft,
      partners,
      documentPartnerName,
    }
  }
)
